import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/base.service';

@Injectable({
    providedIn: 'root'
})

export class FileService extends BaseService {


    public getFiles(idToken: string, fileType: string, searchParams: any, pageSize: number,
        pageIndex: number, endingFileName: string | undefined) {
        
        let queryParams = new HttpParams();
        
        for (const key in searchParams) {
            queryParams = this.appendQueryParam(queryParams, key, searchParams[key]);
        }
        
        queryParams = this.appendQueryParam(queryParams, "per-page", pageSize);
        queryParams = this.appendQueryParam(queryParams, "page", pageIndex + 1);
        queryParams = this.appendQueryParam(queryParams, "ending-file", endingFileName);

        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/files/${fileType}`, { headers, params: queryParams });
    }

    public getUploadUrl(idToken: any, fileType: string, fileName: string) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/file-upload-url/${fileType}/${fileName}`, { headers });
    }

    public uploadFile(file: File, url: string) {
        const headers = new HttpHeaders();
        const formData = new FormData();
        formData.append("file", file);
        return this.httpClient.post(`${url}`, formData, { headers, reportProgress: true, observe: 'events' });
    }

    public getDownloadUrl(idToken: string, fileType: string): Observable<any>;
    public getDownloadUrl(idToken: string, fileType: string, fileName: string): Observable<any>;
    public getDownloadUrl(idToken: string, fileType: string, fileName?: string): Observable<any> {
        const headers = this.getHeaders(idToken);
        const filePath = (fileName == undefined ? fileType : `${fileType}/${fileName}`);
        return this.httpClient.get(`${this.backendDomain}/file-download-url/${filePath}`, { headers });
    }

    public downloadFile(url: string) {
        return this.httpClient.get(`${url}`, { responseType: 'blob', reportProgress: true, observe: 'events' });
    }

    public deleteFile(idToken: string, fileType: string, fileName: string) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.delete(`${this.backendDomain}/file/${fileType}/${fileName}`, { headers });
    }
}